import { API } from 'aws-amplify';

export const resetPassword = (username) => API.put('api', `/admin/users/${username}`, {
  body: {
    reset_password: true
  }
});
